import React, { useState, useEffect, useRef } from "react";

const products = [
  {
    id: 1,
    brand: "Crompton",
    name: "Wave Plus Table Fan",
    tamil: "வேவ் பிளஸ் டேபிள் பேன்",
    price: 2450,
    oldPrice: 3200,
    badge: "HOT",
    offer: "24% OFF",
    category: "Fans",
    img: "/img/b2.png",
    features: ["2 Year Warranty", "Smooth Oscillation", "High Air Delivery"],
  },
  {
    id: 2,
    brand: "Orient Electric",
    name: "Desk 25 Table Fan",
    tamil: "டெஸ்க் 25 டேபிள் பேன்",
    price: 2450,
    oldPrice: null,
    badge: "5 DAYS OFFER",
    offer: null,
    category: "Fans",
    img: "/img/b3.png",
    features: ["100% Copper Motor", "Powerful Air Delivery", "Made in India"],
  },
  {
    id: 3,
    brand: "Lakshmi Sumati",
    name: "Aeromax Tower Fan",
    tamil: "ஏரோமேக்ஸ் டவர் பேன்",
    price: 2299,
    oldPrice: 4600,
    badge: "LIMITED",
    offer: "50% OFF",
    category: "Fans",
    img: "img/b4.png",
    features: ["Low Power Consumption", "Wide Angle Oscillation", "1 Year Warranty"],
  },
  {
    id: 4,
    brand: "HTC",
    name: "AT-118 Hair Clipper",
    tamil: "ஹேர் கிளிப்பர்",
    price: 400,
    oldPrice: null,
    badge: "OFFER",
    offer: null,
    category: "Accessories",
    img: "img/b5.png",
    features: ["2 Speed Setting", "Rechargeable", "T-Blade Design"],
  },
  {
    id: 5,
    brand: "HTC",
    name: "AT-539 Hair Trimmer",
    tamil: "ஹேர் ட்ரிம்மர்",
    price: 630,
    oldPrice: null,
    badge: "ISO 9001",
    offer: null,
    category: "Accessories",
    img: "img/b6.webp",
    features: ["T-Blade Design", "Rechargeable Battery", "Comb Attachment"],
  },
  {
    id: 6,
    brand: "Multi-Brand",
    name: "TV Remote Combo Set",
    tamil: "டிவி ரிமோட் கம்போ செட்",
    price: 95,
    oldPrice: null,
    badge: "HOT",
    offer: null,
    category: "Accessories",
    img: "img/p6.jfif",
    features: ["HD 1920x1080 Support", "Power upto 50W", "Full Combo Set"],
  },
  {
    id: 7,
    brand: "Auto Lock",
    name: "Bike Cable Lock",
    tamil: "பைக் லாக்",
    price: 100,
    oldPrice: null,
    badge: "OFFER",
    offer: null,
    category: "Accessories",
    img: "img/p7.png",
    features: ["2 Keys Included", "Strong Steel Cable", "Anti-Theft"],
  },
  {
    id: 8,
    brand: "Aro-Flex",
    name: "Wire Coil 2.5 sq.mm",
    tamil: "வயர் காயில்",
    price: 1350,
    oldPrice: null,
    badge: "5 DAYS",
    offer: null,
    category: "Electrical",
    img: "img/p8.png",
    features: ["Fast Delivery", "Quality Guaranteed", "All Colors Available"],
  },
  {
    id: 9,
    brand: "Exide",
    name: "Xplore Bike Battery",
    tamil: "பைக் பேட்டரி",
    price: null,
    oldPrice: null,
    badge: "48 MONTH",
    offer: null,
    category: "Battery",
    img: "img/p9.png",
    features: ["48 Month Warranty", "Maintenance Free", "High CCA"],
  },
  {
    id: 10,
    brand: "Luminous",
    name: "Home Inverter",
    tamil: "ஹோம் இன்வெர்ட்டர்",
    price: null,
    oldPrice: null,
    badge: "BEST SELLER",
    offer: null,
    category: "Battery",
    img: "img/p10.png",
    features: ["Pure Sine Wave", "Fast Charging", "LCD Display"],
  },
  {
    id: 18,
    brand: "Microtek",
    name: "Home Inverter",
    tamil: "மைக்ரோடெக் இன்வெர்ட்டர்",
    price: null,
    oldPrice: null,
    badge: "TRUSTED BRAND",
    offer: null,
    category: "Battery",
    img: "/img/b12.png",
    features: ["Pure Sine Wave Output", "Overload Protection", "Long Backup Time"],
  },
  {
    id: 11,
    brand: "Tata Play",
    name: "HD DTH Connection",
    tamil: "டிடிஹெச் இணைப்பு",
    price: null,
    oldPrice: null,
    badge: "NEW",
    offer: null,
    category: "DTH",
    img: "img/p11.png",
    features: ["HD Channels", "Installation Included", "All Packages"],
  },
  {
    id: 12,
    brand: "Solar",
    name: "Solar Kit Complete",
    tamil: "சோலார் கிட்",
    price: null,
    oldPrice: null,
    badge: "POPULAR",
    offer: null,
    category: "Solar",
    img: "img/p12.png",
    features: ["Solar Panel", "Tubular Battery", "Charge Controller"],
  },
  {
    id: 13,
    brand: "Custom Assembly",
    name: "Vehicle Amplifier & Speaker Set",
    tamil: "வாகன ஆம்ப்ளிஃபையர் & ஸ்பீக்கர்",
    price: null,
    oldPrice: null,
    badge: "CUSTOM FIT",
    offer: null,
    category: "Vehicle Audio",
    img: "img/b7.png",
    features: [
      "Amplifiers, Speakers, Micro Chips & Volume Buttons — all in one place",
      "Custom-designed assembly per customer preference",
      "Special wholesale discount for technicians",
    ],
  },
  {
    id: 19,
    brand: "Samcon",
    name: "Woofer & Sub Woofer Set",
    tamil: "வூஃபர் & சப் வூஃபர்",
    price: null,
    oldPrice: null,
    badge: "BASS BOOST",
    offer: null,
    category: "Vehicle Audio",
    img: "/img/b13.png",
    features: ["Deep Bass Output", "Vehicle & Home Use", "Durable Cone Design"],
  },
  {
    id: 14,
    brand: "Multi-Brand",
    name: "Rechargeable LED Torch Light",
    tamil: "ரீசார்ஜபிள் டார்ச் லைட்",
    price: null,
    oldPrice: null,
    badge: "FARM USE",
    offer: null,
    category: "Lighting",
    img: "img/b8.png",
    features: ["Long Battery Life", "Bright LED Beam", "Durable Build"],
  },
  {
    id: 15,
    brand: "Solar",
    name: "Solar Headlamp & Torch",
    tamil: "சோலார் நெத்தி லைட்",
    price: null,
    oldPrice: null,
    badge: "SOLAR",
    offer: null,
    category: "Lighting",
    img: "img/b9.png",
    features: ["Solar Charging", "Hands-Free Headlamp", "Works in No-Power Areas"],
  },
  {
    id: 16,
    brand: "Metro / Escorts",
    name: "Digital Weighing Scale",
    tamil: "டிஜிட்டல் எடை இயந்திரம்",
    price: null,
    oldPrice: null,
    badge: "FOR SHOPS",
    offer: null,
    category: "Commercial",
    img: "img/b10.png",
    features: ["Platform & Hand Scales", "Milk/Liquid Litre Scales", "Retail & Wholesale Available"],
  },
  {
    id: 17,
    brand: "Multi-Brand",
    name: "Commercial Double Stove",
    tamil: "வணிக டபுள் அடுப்பு",
    price: null,
    oldPrice: null,
    badge: "12x12 / 14x14",
    offer: null,
    category: "Commercial",
    img: "img/b11.png",
    features: ["For Food Business Use", "12x12 & 14x14 inch Sizes", "Heavy Duty Build"],
  },
  {
    id: 20,
    brand: "Multi-Brand",
    name: "RO Water Purifier System",
    tamil: "RO வாட்டர் சிஸ்டம்",
    price: null,
    oldPrice: null,
    badge: "PURE WATER",
    offer: null,
    category: "Home Appliances",
    img: "/img/b15.png",
    features: ["Multi-Stage Purification", "Installation Included", "Annual Maintenance Available"],
  },
  {
    id: 21,
    brand: "Multi-Brand",
    name: "Gas Hose & Regulator Set",
    tamil: "கேஸ் ஹோஸ் & ரெகுலேட்டர்",
    price: null,
    oldPrice: null,
    badge: "SAFETY CERTIFIED",
    offer: null,
    category: "Home Appliances",
    img: "/img/b14.png",
    features: ["ISI Marked", "Leak-Proof Design", "Fits All Standard Stoves"],
  },

  /* ── NEW: Drone & Robotics ── */
  {
    id: 22,
    brand: "Multi-Brand",
    name: "Agricultural Spraying Drone",
    tamil: "விவசாய ஸ்ப்ரே ட்ரோன்",
    price: null,
    oldPrice: null,
    badge: "NEW",
    offer: null,
    category: "Drone & Robotics",
    img: "/img/b18.png",
    features: ["For Farm Pesticide Spraying", "Remote Controlled", "High Capacity Tank"],
  },
{
  id: 23,
  brand: "Multi-Brand",
  name: "4K Camera Drone",
  tamil: "4K கேமரா ட்ரோன்",
  price: null,
  oldPrice: null,
  badge: "NEW ARRIVAL",
  offer: null,
  category: "Drone & Robotics",
  img: "/img/b17.png",
  features: [
    "4K Ultra HD Dual Camera",
    "GPS Navigation & Auto Return",
    "Foldable Portable Design"
  ],
},
  {
    id: 24,
    brand: "Multi-Brand",
    name: "Drone Spare Parts & Motors",
    tamil: "ட்ரோன் உதிரி பாகங்கள்",
    price: null,
    oldPrice: null,
    badge: "SPARES",
    offer: null,
    category: "Drone & Robotics",
    img: "/img/b16.png",
    features: ["Brushless Motors", "Propellers & ESCs", "Repair & Upgrade Support"],
  },
  {
  id: 25,
  brand: "Multi-Brand",
  name: "Mixer Grinder (Mixie)",
  tamil: "மிக்ஸி",
  price: null,
  oldPrice: null,
  badge: "KITCHEN ESSENTIAL",
  offer: null,
  category: "Home Appliances",
  img: "/img/b19.png",
  features: ["Multiple Jars Included", "Powerful Motor", "Original Spare Parts Available"],
},
{
  id: 26,
  brand: "Multi-Brand",
  name: "Wet Grinder",
  tamil: "கிரைண்டர்",
  price: null,
  oldPrice: null,
  badge: "BEST SELLER",
  offer: null,
  category: "Home Appliances",
  img: "/img/b20.png",
  features: ["Smooth Grinding Stone", "Durable Motor", "Spare Parts Available"],
},
{
  id: 27,
  brand: "Multi-Brand",
  name: "Washing Machine",
  tamil: "வாஷிங் மெஷின்",
  price: null,
  oldPrice: null,
  badge: "TRUSTED BRAND",
  offer: null,
  category: "Home Appliances",
  img: "/img/b21.png",
  features: ["Semi & Fully Automatic Options", "Energy Efficient", "After-Sales Support"],
},
{
  id: 28,
  brand: "Multi-Brand",
  name: "Voltage Stabilizer",
  tamil: "ஸ்டெபிலைசர்",
  price: null,
  oldPrice: null,
  badge: "PROTECTION",
  offer: null,
  category: "Home Appliances",
  img: "/img/b22.png",
  features: ["Surge Protection", "For TV/Fridge/AC Use", "Wide Voltage Range"],
},
];

const categories = [
  "All",
  "Fans",
  "Battery",
  "Electrical",
  "Accessories",
  "Solar",
  "DTH",
  "Vehicle Audio",
  "Lighting",
  "Commercial",
  "Home Appliances",
  "Drone & Robotics", // ← new
];

const ITEMS_PER_PAGE = 8;

export const Products = () => {
  const [active, setActive] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const filtered =
    active === "All" ? products : products.filter((p) => p.category === active);

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginated = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handleCategoryChange = (cat) => {
    setActive(cat);
    setCurrentPage(1);
  };

  const goToPage = (page) => {
    setCurrentPage(page);
    document.getElementById("products")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="products" ref={sectionRef}>
      <div className="container">
        {/* Title */}
        <div className="section-title text-center">
          <h2>
            <span>Products</span>
          </h2>
          <hr style={{ margin: "0 auto 20px", width: "70px" }} />
          <p>சிறந்த தரம் · சிறந்த விலை · நம்பகமான பிராண்டுகள்</p>
        </div>

        {/* Filter Tabs */}
        <div className="product-filters text-center">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-tab ${active === cat ? "active" : ""}`}
              onClick={() => handleCategoryChange(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Product Grid */}
        <div className="products-grid">
          {paginated.map((p) => (
            <div className="product-card" key={p.id}>
              {/* Image */}
              <div className="product-img-wrap">
                <img
                  src={p.img}
                  alt={p.name}
                  className="product-img"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
                <div className="product-img-fallback">📦</div>

                {/* Badges */}
                {p.badge && <span className="badge-hot">{p.badge}</span>}
                {p.offer && <span className="badge-off">{p.offer}</span>}
              </div>

              {/* Body */}
              <div className="product-body">
                <div className="product-brand">{p.brand}</div>
                <div className="product-name">{p.name}</div>
                <div className="product-tamil">{p.tamil}</div>

                {/* Features */}
                <ul className="product-features">
                  {p.features.map((f, i) => (
                    <li key={i}>✓ {f}</li>
                  ))}
                </ul>

                {/* Price Row */}
                <div className="product-price-row">
                  {p.price ? (
                    <>
                      <span className="product-price">₹{p.price.toLocaleString()}</span>
                      {p.oldPrice && (
                        <span className="product-old-price">
                          ₹{p.oldPrice.toLocaleString()}
                        </span>
                      )}
                    </>
                  ) : (
                    <span className="product-price-call">Call for Price</span>
                  )}
                </div>

                {/* Button */}
                <a href="tel:+919042011186" className="product-btn">
                  📞 Enquire Now
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              className="page-btn page-nav"
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              ‹ Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                className={`page-btn ${currentPage === page ? "active" : ""}`}
                onClick={() => goToPage(page)}
              >
                {page}
              </button>
            ))}

            <button
              className="page-btn page-nav"
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next ›
            </button>
          </div>
        )}

        {/* Bottom note */}
        <div className="products-note text-center">
          <p>
            மேலும் பொருட்களுக்கு நேரில் வருக அல்லது அழைக்கவும் —{" "}
            <a href="tel:+919042011186">
              <strong>90420 11186</strong>
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};